import {useNavbar} from "../states/common/client";
import {useEffect} from "react";
import {useGetNoticesParam} from "../states/notice/client/hooks";
import {useGetNotices} from "../states/notice/server";
import {List} from "@mui/material";
import {NoticeListItem} from "../components/notice/NoticeListItem";

export default function NoticePage() {
    // hooks
    const { setNavbarTitle, reset } = useNavbar()
    const { getNoticesParam, setPage } = useGetNoticesParam()

    // queries
    const { data: noticePage } = useGetNotices(getNoticesParam)

    useEffect(() => {
        reset()
        setNavbarTitle("공지사항")
    }, [])

    // TODO 무한스크롤
    return (
        <div className={"fullscreen"}>
            <List>
                {noticePage?.content.map(notice => (
                    <NoticeListItem key={notice.id} notice={notice} />
                ))}
            </List>
        </div>)
}